import { render } from "./widget-paroprovod.vue?vue&type=template&id=fb3e1946"
import script from "./widget-paroprovod.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-paroprovod.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-grid/components/widgets/widget-paroprovod.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb3e1946"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb3e1946', __exports__)) {
    api.reload('fb3e1946', __exports__)
  }
  
  module.hot.accept("./widget-paroprovod.vue?vue&type=template&id=fb3e1946", () => {
    api.rerender('fb3e1946', render)
  })

}


export default __exports__